// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ZP_y","clinicsSelect":"styles_clinicsSelect__z1PzE"};